import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import "react-image-gallery/styles/css/image-gallery.css";
import { ProgressBar } from './progress-bar';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

interface SliderContainerProps {
    image: any;
    height: string;
}

export default function SliderContainer({ image, height }: SliderContainerProps) {

    const { t } = useTranslation();
    const location = useLocation().pathname;


    return (
        <div className="custom-image-container marg-custom-40">
            <ReactCompareSlider
                itemOne={<ReactCompareSliderImage src={image.originalImage ? image.originalImage : ""} alt="Before" className="img-slide" />}
                itemTwo={<ReactCompareSliderImage src={image.src ? image.src : ""} alt="After" className="img-slide" />}
            />

            {(image.image_quality_score  || image.image_sizekb || image.brightness ) && (
                <ProgressBar
                    image={image}
                    height={height}
                    ItemProgressContainer="progress-container"
                    ItemProgressBar="progress-bar"
                />
            )}

            <div className="header-img--block header-img--block-before">{t("propertyDetails.original")}</div>
            <div className="header-img--block header-img--block-after">{t("propertyDetails.enhanced")}</div>
        </div>
    );
}

